import { useContent } from '@/stores/RootStore';
import { observer } from 'mobx-react-lite';
import s from './OrgChart.module.scss';

// 조직도 — evstech 조직 이미지를 EVS 컨셉(네이비+시안, 심플·현대)으로 벡터 재해석(2026-08-02).
//   경영(시안 상위노드) → 3본부 카드(네이비) → 팀 카드(라이트+시안보더) → 업무 칩.
//   커넥터는 CSS 라인(반응형·크리스프). 데이터는 mockData.ORG_CHART.
const OrgChart = observer(() => {
  const { orgChart } = useContent();
  return (
    <div className={s.chart}>
      {/* 최상위: 경영 */}
      <div className={s.rootRow}>
        <div className={s.rootNode}>{orgChart.root}</div>
      </div>
      <div className={s.trunk} aria-hidden />

      {/* 본부 3열 */}
      <div className={s.divisions}>
        {orgChart.divisions.map((div) => (
          <div key={div.label} className={s.divCol}>
            <div className={s.connectorTop} aria-hidden />
            <div className={s.divCard}>{div.label}</div>
            <div className={s.teams}>
              {div.teams.map((team) => (
                <div key={team.label} className={s.teamCard}>
                  <div className={s.teamName}>{team.label}</div>
                  {team.items.length > 0 && (
                    <ul className={s.items}>
                      {team.items.map((it) => (
                        <li key={it} className={s.item}>{it}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default OrgChart;
